// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  padding: 0;
}

body {
  font-family: "Manrope", sans-serif;
  width: 100%;
  display: block !important;
  background: white !important;
  overflow-x: hidden;
}
.card {
  padding: 0;
}
/* .row > * {
  padding-right: 0 !important;
  padding-left: 0 !important;
} */
.min-height{
  min-height: 70vh;
}
.width-full-page {
  width: 80%;
  z-index: 1;
}

.card-head-width {
  width: 80%;
}
@media (max-width: 768px) {
  .width-full-page {
    width: 100%;
    padding: 2%;
  }
  .custom-text-center{
    text-align: center;
  }
  .custom-footer-text{
    display: flex;
    justify-content: center;
  }
}



/* -----------------------------  render pages style  -------------------------------- */

.span-with-violet {
  color: #4733C9;
  font-weight: bold;
}
.span-with-violet-mail {
  color: #4733C9;
  font-weight: 700;
  font-family: "Manrope", sans-serif;
}

.line-span {
  width: 100%;
  position: relative;
}
.line-div {
  width: 100%;
  border-bottom: 1.5px solid #707070;
  position: absolute;
  bottom: 7px;
}

.line-div-max-length {
  width: 100%;
  border-bottom: 0.5px solid #707070a2;
  position: absolute;
  /* bottom: 7px; */ 
 
  max-width: 150px;
  height: 6px;
  top: 100%;
}

/* --------------------------------- Headings ------------------------------------------- */
.heading-pages {
  font-family: "Poppins", sans-serif;
  /* line-height: 60px; */
  font-weight: 700;
  font-size: 30px;
  text-align: center;
  color: #333132;
}
.sub-div-headings {
  font-family: "Manrope", sans-serif;
  font-weight: 800;
  font-size: 24px;
  /* text-wrap: nowrap; */
}
.inner-text-heading {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 18px;
 }

.inner-text-heading-two {
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  font-size: 16px;
 }

.inner-text-heading-three {
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 14px;
 }

/* --------------------------------- Headings ------------------------------------------- */

/* ------------------------------------- inner content  ---------------------------------------- */

.sub-text-pages {
  font-size: 16px;
  color: #333132;
  font-weight: 700;
  font-family: "Manrope", sans-serif;
}
.inner-text-content {
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #333132;
}

.inner-text-content-two {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #333132;
}

.inner-text-content-three {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #333132;
}

.inner-text-content-four {
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #707070;
}
.inner-text-content-five {
  font-family: "Manrope", sans-serif;
  font-weight: 450;
  font-size: 16px;
  color: #333132;
}
/* ------------------------------------- inner content  ---------------------------------------- */

.violet-button-style {
  background-color: #4733C9;
  color: white;
  border-color: white !important;
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 20px;
  padding: 5px;
}
.violet-transparent-button-style {
  background-color: transparent;
  color: #4733C9;
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 14px;
  border-radius: 5px;
  outline: 1px solid #4733C9;
}

.list-about-us {
  list-style-position: outside;
}

.list-about-us li {
  padding-top: 40px;
}

.background-light- violet {
  background-color: #ecfff3;
}

.card-howitswork {
  border: 0.5px solid #eeeeee !important;
  box-shadow: none !important;
}

.number-div-height {
  height: 75px;
}
.card-number-head {
  background-color: #4733C9;
  padding: 10px;
  padding-top: 7px;
  padding-bottom: 7px;
  font-size: 26px;
  font-family: "Manrope", sans-serif;
  font-weight: 700;
  border-radius: 50%;
  color: white;
}

.accordion-custom {
  --bs-accordion-active-color: #4733C9 !important;
  --bs-accordion-active-bg: none !important;
  border-bottom: 1px solid #d9d9d9;
  --bs-accordion-btn-focus-box-shadow: none !important;
}
.how-it-works-img{
  max-height: 200px;
  align-items: center;
}
.lilo-email-link{
  color: #4733C9;
}`, "",{"version":3,"sources":["webpack://./src/pages/css/styles.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;;;GAGG;AACH;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;AACA;EACE;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;AACF;;;;AAIA,wFAAwF;;AAExF;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;;EAEjB,gBAAgB;EAChB,WAAW;EACX,SAAS;AACX;;AAEA,2FAA2F;AAC3F;EACE,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;CAChB;;AAED;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;CAChB;;AAED;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;CAChB;;AAED,2FAA2F;;AAE3F,kGAAkG;;AAElG;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA,kGAAkG;;AAElG;EACE,yBAAyB;EACzB,YAAY;EACZ,8BAA8B;EAC9B,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,yCAAyC;EACzC,gCAAgC;EAChC,oDAAoD;AACtD;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB","sourcesContent":["#root {\n  padding: 0;\n}\n\nbody {\n  font-family: \"Manrope\", sans-serif;\n  width: 100%;\n  display: block !important;\n  background: white !important;\n  overflow-x: hidden;\n}\n.card {\n  padding: 0;\n}\n/* .row > * {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n} */\n.min-height{\n  min-height: 70vh;\n}\n.width-full-page {\n  width: 80%;\n  z-index: 1;\n}\n\n.card-head-width {\n  width: 80%;\n}\n@media (max-width: 768px) {\n  .width-full-page {\n    width: 100%;\n    padding: 2%;\n  }\n  .custom-text-center{\n    text-align: center;\n  }\n  .custom-footer-text{\n    display: flex;\n    justify-content: center;\n  }\n}\n\n\n\n/* -----------------------------  render pages style  -------------------------------- */\n\n.span-with-violet {\n  color: #4733C9;\n  font-weight: bold;\n}\n.span-with-violet-mail {\n  color: #4733C9;\n  font-weight: 700;\n  font-family: \"Manrope\", sans-serif;\n}\n\n.line-span {\n  width: 100%;\n  position: relative;\n}\n.line-div {\n  width: 100%;\n  border-bottom: 1.5px solid #707070;\n  position: absolute;\n  bottom: 7px;\n}\n\n.line-div-max-length {\n  width: 100%;\n  border-bottom: 0.5px solid #707070a2;\n  position: absolute;\n  /* bottom: 7px; */ \n \n  max-width: 150px;\n  height: 6px;\n  top: 100%;\n}\n\n/* --------------------------------- Headings ------------------------------------------- */\n.heading-pages {\n  font-family: \"Poppins\", sans-serif;\n  /* line-height: 60px; */\n  font-weight: 700;\n  font-size: 30px;\n  text-align: center;\n  color: #333132;\n}\n.sub-div-headings {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 800;\n  font-size: 24px;\n  /* text-wrap: nowrap; */\n}\n.inner-text-heading {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n }\n\n.inner-text-heading-two {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n }\n\n.inner-text-heading-three {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n }\n\n/* --------------------------------- Headings ------------------------------------------- */\n\n/* ------------------------------------- inner content  ---------------------------------------- */\n\n.sub-text-pages {\n  font-size: 16px;\n  color: #333132;\n  font-weight: 700;\n  font-family: \"Manrope\", sans-serif;\n}\n.inner-text-content {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  color: #333132;\n}\n\n.inner-text-content-two {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  color: #333132;\n}\n\n.inner-text-content-three {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #333132;\n}\n\n.inner-text-content-four {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  color: #707070;\n}\n.inner-text-content-five {\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 450;\n  font-size: 16px;\n  color: #333132;\n}\n/* ------------------------------------- inner content  ---------------------------------------- */\n\n.violet-button-style {\n  background-color: #4733C9;\n  color: white;\n  border-color: white !important;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 20px;\n  padding: 5px;\n}\n.violet-transparent-button-style {\n  background-color: transparent;\n  color: #4733C9;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 5px;\n  outline: 1px solid #4733C9;\n}\n\n.list-about-us {\n  list-style-position: outside;\n}\n\n.list-about-us li {\n  padding-top: 40px;\n}\n\n.background-light- violet {\n  background-color: #ecfff3;\n}\n\n.card-howitswork {\n  border: 0.5px solid #eeeeee !important;\n  box-shadow: none !important;\n}\n\n.number-div-height {\n  height: 75px;\n}\n.card-number-head {\n  background-color: #4733C9;\n  padding: 10px;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  font-size: 26px;\n  font-family: \"Manrope\", sans-serif;\n  font-weight: 700;\n  border-radius: 50%;\n  color: white;\n}\n\n.accordion-custom {\n  --bs-accordion-active-color: #4733C9 !important;\n  --bs-accordion-active-bg: none !important;\n  border-bottom: 1px solid #d9d9d9;\n  --bs-accordion-btn-focus-box-shadow: none !important;\n}\n.how-it-works-img{\n  max-height: 200px;\n  align-items: center;\n}\n.lilo-email-link{\n  color: #4733C9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
